import { Vue, Component, Prop } from "vue-property-decorator";
import { ArtistTypeEnum, PlanOrderHistoryPaymentStatusEnum, PlanOrderHistoryPaymentMethodEnum } from '@/generated/api';
import addDays from 'date-fns/addDays';
import parseDateTime from 'date-fns/parseISO';
import formatDateTime from 'date-fns-tz/esm/format';
import { addMinutes } from 'date-fns';
import { State } from 'vuex-class';

@Component
export default class SBComponentVue extends Vue {
    @State('en')
    public langEnglish!: boolean;

    @Prop({
        type: String,
        default: "",
    })
    public enSlot!: string;

    public getArtistType(type: ArtistTypeEnum) {
        switch (type) {
            case ArtistTypeEnum.SPORTS:
                return "SPORTS"
            case ArtistTypeEnum.TALENT:
                return "TALENT"
            case ArtistTypeEnum.VOICEACTOR:
                return "VOICEACTOR"
            case ArtistTypeEnum.VTUBER:
                return "VTUBER"
            case ArtistTypeEnum.YOUTUBER:
                return "YOUTUBER"
            case ArtistTypeEnum.GAME:
                return "GAME"
            case ArtistTypeEnum.ANIME:
                return "ANIME"
            case ArtistTypeEnum.ENTERTAINER:
                return "ENTERTAINER"
            case ArtistTypeEnum.COMICS:
                return "COMICS"
            case ArtistTypeEnum.ARTIST:
                return "ARTIST"
            case ArtistTypeEnum.SINGER:
                return "SINGER"
            case ArtistTypeEnum.CHARACTER:
                return "CHARACTER"
            case ArtistTypeEnum.LIVER:
                return "LIVER"
            case ArtistTypeEnum.ILLUSTRATOR:
                return "ILLUSTRATOR"
            case ArtistTypeEnum.OTHER:
                return "OTHER"
            case ArtistTypeEnum.EVENT:
                return "SPECIAL"
            default:
                return ""
        }
    }

    public toArtistType(type: string) {
        switch (type) {
            case "sports":
                return ArtistTypeEnum.SPORTS
            case "talent":
                return ArtistTypeEnum.TALENT
            case "voiceactor":
                return ArtistTypeEnum.VOICEACTOR
            case "vtuber":
                return ArtistTypeEnum.VTUBER
            case "youtuber":
                return ArtistTypeEnum.YOUTUBER
            case "game":
                return ArtistTypeEnum.GAME
            case "anime":
                return ArtistTypeEnum.ANIME
            case "entertainer":
                return ArtistTypeEnum.ENTERTAINER
            case "comics":
                return ArtistTypeEnum.COMICS
            case "artist":
                return ArtistTypeEnum.ARTIST
            case "singer":
                return ArtistTypeEnum.SINGER
            case "character":
                return ArtistTypeEnum.CHARACTER
            case "liver":
                return ArtistTypeEnum.LIVER
            case "other":
                return ArtistTypeEnum.OTHER
            case "event":
                return "SPECIAL"
            default:
                return ""
        }
    }

    public getPaymentStatus(type: PlanOrderHistoryPaymentStatusEnum) {
        switch (type) {
            case PlanOrderHistoryPaymentStatusEnum.BEFORE:
                return "決済実行中"
            case PlanOrderHistoryPaymentStatusEnum.CANCEL:
                return "決済キャンセル"
            case PlanOrderHistoryPaymentStatusEnum.ERROR:
                return "決済失敗"
            case PlanOrderHistoryPaymentStatusEnum.SUCCESS:
                return "決済確定済み/商品生産中"
            case PlanOrderHistoryPaymentStatusEnum.WAITING:
                return "決済確定済み/出荷準備中"
            case PlanOrderHistoryPaymentStatusEnum.SHIPSTART:
                return "決済確定済み/出荷済み"
            case PlanOrderHistoryPaymentStatusEnum.COMPLETEMAIL:
                return "決済確定済み/出荷済み"
            default:
                return ""
        }
    }

    // errorTranslation(error)
    public errorTranslation(error: string) {
        if (!this.langEnglish) {
            return error;
        }

        switch (error) {
            case "お手数ですがログインし直してください。":
                return "Please then try again."
            case "メールアドレスを正しく入力してください。":
                return "Please enter your e-mail address correctly."
            case "メールアドレスの入力に複数回誤りがありました。お手数ですがお問い合わせよりサポートへご連絡ください。":
                return "Please wait a while and then try again."
            case "メールアドレスの入力に複数回誤りがありました。しばらく経ってから再度お試してください。":
                return "Please wait a while and then try again."
            case "しばらく待ってから再度実行してください。お手数ですがお問い合わせよりサポートへご連絡ください。":
                return "Please wait a while and then try again."
            case "正しい認証コードを入力してください。":
                return "Authentication code is incorrect."
            case "メールアドレス・パスワードが違います":
                return "E-mail address is wrong, or password is wrong."
            case "利用規約・個人情報保護方針に同意してください。":
                return "Please agree with the Terms of Service and Privacy Policy."
            case "パスワードが一致しません。":
                return "Passwords do not match"
            default:
                ;
        }

        //複数返す場合
        error = error.replace("メールアドレスを正しく入力してください。", "Please enter name within  200 characters.")
        error = error.replace("お名前が未入力です。", "Please enter name within  200 characters.")
        error = error.replace("お名前が未入力です。", "Please enter your name.")
        error = error.replace("お名前を200文字以下で入力してください。", "Please enter name within  200 characters.")
        error = error.replace("メールアドレスが未入力です。", "Email address has not been entered.")
        error = error.replace("200文字以上のメールアドレスは登録できません。", "You can’t register email address more than 200 characters.")
        error = error.replace("電話番号が未入力です。", "Phone number has not been entered.")
        error = error.replace("電話番号は11文字以内で入力してください。", "Please enter phone number within 11 characters.")
        error = error.replace("電話番号を半角数字ハイフン無しで入力してください。", "Please enter the phone number without hyphens.")
        error = error.replace("生年月日が未入力です。", "The date of birth has not been entered.")
        error = error.replace("郵便番号が未入力です。", "The postal code has not been entered.")
        error = error.replace("郵便番号を半角数字ハイフン無しで入力してください。", "Please enter postal code without hyphens.")
        error = error.replace("郵便番号は7文字で入力してください。", "Please enter the postal code within 7 characters.")
        error = error.replace("住所を自動入力してください。", "Please enter the street address automatically.")
        error = error.replace("住所を200文字以下で入力してください。", "Please enter street address within 200 characters.")
        error = error.replace("住所2が未入力です。", "Street address 2 has not been entered.")
        error = error.replace("住所2には半角数字を含めて入力してください。", "Please enter half-width numbers in street address2.")
        error = error.replace("住所2を200文字以下で入力してください。", "Please enter  street address2 within 200 characters.")
        error = error.replace("パスワードは半角英字と半角数字それぞれ1文字以上含む8文字以上100文字以下で入力してください。", "Please enter password from 8 to 100 characters, including 1 or more letters and numbers.")
        return error;
    }

    public comma(value: number): string {
        return new Intl.NumberFormat('ja-JP', { style: 'decimal' }).format(value);
    }

    public dateParse(value: string | Date): Date {
        if (value instanceof Date) {
            return value;
        } else if (typeof value === "string") {
            return parseDateTime(value);
        } else {
            return parseDateTime("" + value);
        }
    }

    public dateFormat(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy年MM月dd日p", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateFormatDate(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy年MM月dd日", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateFormatSimple(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy/MM/dd", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateAddDay(value: string | Date, day: number): Date {
        return addDays(this.dateParse(value), day);
    }

    public dateAddMinutes(value: string | Date, minutes: number): Date {
        return addMinutes(this.dateParse(value), minutes);
    }

    public textPaymentMethod(value: PlanOrderHistoryPaymentMethodEnum): { title: string; attention: string; } {
        switch (value) {
            case PlanOrderHistoryPaymentMethodEnum.CARD:
                return { title: "クレジットカード", attention: "Visa / Mastercard / JCB / American Express / Diners Club<br>サプライズボックスでは、サイト上でクレジットカードを保存しないようにしている為、決済入力ページはGMOペイメントゲートウェイ株式会社様のページになりURLが変わりますが、クレジットカードの情報漏えいはございませんのでご安心ください。" };
            case PlanOrderHistoryPaymentMethodEnum.GMOAB:
                return { title: "GMO後払い(コンビニ・銀行・LINE Pay等)※1申込みごとに別途200円(税抜)必要", attention: "配送先住所は、自宅または勤務先をご入力ください。請求書の発行と債権譲渡の為、配送先情報(氏名・住所・電話番号・メールアドレス等)を弊社よりGMOペイメントサービス株式会社に提供いたします。審査によりご利用できないことがあります。<br><a href=\"http://www.gmo-ps.com/customer_2/\" target=\"_blank\">詳細はこちらからご確認ください</a>" };
        }
        throw "存在しない決済方法";
    }

    public getCommission(payAt: string, preTax: boolean): number {
        if (payAt < "2020-03-11") {//GMOABの手数料が5月号から200円から220円に値上がりした為
            return preTax ? this.oldPreTaxcommission : this.oldCommission;
        } else {
            return preTax ? this.preTaxcommission : this.commission;
        }
    }

    public getCommission2(preTax: boolean): number {
        return preTax ? this.preTaxcommission : this.commission;
    }

    private oldPreTaxcommission: number = 182;
    private oldCommission: number = 200;

    private preTaxcommission: number = 200;
    private commission: number = 220;
}
